import moment from 'moment'

/**
 * Calculate the new price
 * information after the overwrite
 * @param currentPostedPrice
 * @param isAbsolute
 * @param amount
 */
function calculatePriceDifference(currentPostedPrice, isAbsolute, amount) {
  const newPrice = calcCustomPrice(
    currentPostedPrice.customPrice || currentPostedPrice.price,
    isAbsolute,
    amount
  )
  const currentPrice =
    currentPostedPrice.customPrice || currentPostedPrice.customPrice === 0
      ? currentPostedPrice.customPrice
      : currentPostedPrice.price
  const priceDifference = newPrice - currentPrice
  return {
    oldPrice: currentPrice,
    priceDifference,
    newPrice,
  }
}

/**
 * Calculate the old price
 * information to reset
 * @param currentPostedPrice
 */
function calculateResetPriceDifference(currentPostedPrice) {
  const oldPrice =
    currentPostedPrice.customPrice || currentPostedPrice.customPrice === 0
      ? currentPostedPrice.customPrice
      : currentPostedPrice.price

  const priceDifference =
    (currentPostedPrice.customPrice || currentPostedPrice.customPrice === 0) &&
    currentPostedPrice.price
      ? currentPostedPrice.price - currentPostedPrice.customPrice
      : 0

  return {
    oldPrice,
    priceDifference,
    newPrice: currentPostedPrice.price,
  }
}

/**
 * Helper function to calculate correct custom price based of the old price.
 * Stolen from PE implementation ;)
 * @param currentPrice
 * @param isAbsolute
 * @param amount
 *
 * @private
 */
function calcCustomPrice(currentPrice, isAbsolute, amount) {
  if (isAbsolute) {
    if (amount < 0) {
      throw new Error('User cannot set a negative absolute custom price!')
    }
    // acount for cents processed as whole number
    return amount * 100
  } else {
    return Math.round(currentPrice + (currentPrice / 100) * amount)
  }
}

export const calculateResetPrices = async (
  productDefinitions,
  currentPostedPrices,
  overwriteDates
) => {
  const postedPricesAtOverwriteDates = currentPostedPrices.filter(
    (postedPrice) =>
      overwriteDates.includes(moment(postedPrice.validAt).format('YYYY-MM-DD'))
  )
  const tableData = postedPricesAtOverwriteDates.map((postedPrice) => {
    const priceData = calculateResetPriceDifference(postedPrice)
    const currentProdDef = productDefinitions.find(
      (prodDef) => prodDef.id === postedPrice.productDefinitionId
    )
    return {
      date: moment(postedPrice.validAt).format('YYYY-MM-DD'),
      ...priceData,
      productDefinitionTranslation: currentProdDef.translation,
    }
  })

  return tableData
}

export const calculateCustomPrices = async (
  productDefinitions,
  currentPostedPrices,
  overwriteDates,
  isAbsolute,
  amount
) => {
  const postedPricesAtOverwriteDates = currentPostedPrices.filter(
    (postedPrice) =>
      overwriteDates.includes(moment(postedPrice.validAt).format('YYYY-MM-DD'))
  )

  const tableData = postedPricesAtOverwriteDates.map((postedPrice) => {
    const currentProdDef = productDefinitions.find(
      (prodDef) => prodDef.id === postedPrice.productDefinitionId
    )
    const priceData = calculatePriceDifference(postedPrice, isAbsolute, amount)
    return {
      date: moment(postedPrice.validAt).format('YYYY-MM-DD'),
      ...priceData,
      productDefinitionTranslation: currentProdDef.translation,
    }
  })

  return tableData
}
